import { Flex, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import { Route } from 'application/Shared/Helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export const SwitchToAgentDeployment = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });
    return (
        <Flex
            alignItems="center"
            data-testid="onboardingQuickScanSwitchToAgentDeployment"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Link
                to={`${basePartnerRoute}/onboarding/deployAgent/select`}
                style={{
                    alignSelf: 'center',
                    marginBottom: '16px',
                    marginTop: '128px'
                }}
            >
                <Text
                    color={theme.palette.onboarding.buttonPrimary}
                    fontWeight={600}
                    style={{
                        textTransform: 'uppercase'
                    }}
                >
                    {t('Onboarding.quickScan.footer.switchToDeployAgent')}
                </Text>
            </Link>
        </Flex>
    );
};
